import { render, staticRenderFns } from "./jxsdzd.vue?vue&type=template&id=f6894bbc&scoped=true&"
import script from "./jxsdzd.vue?vue&type=script&lang=js&"
export * from "./jxsdzd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6894bbc",
  null
  
)

export default component.exports